module.exports = __webpack_public_path__ + "img/barrage_prize_08.d09b7542.png";